import React from "react";

const InterestReportTable = (props) => {
  const { data, seg, totalMTF } = props;

  const tableData =
    seg === "dpc"
      ? data?.intrestReport
      : seg === "prop"
      ? data?.IntrestProp
      : data?.IntrestMtf;

  const tableStyle = seg === "prop" || seg === "dpc" ? { width: "300%" } : {};

  

  return (
    <>
      {tableData?.length > 0 && (
        <div className="table-responsive scroll-table report-table-wrapper ">
          <table className="table last-column" style={tableStyle}>
            <thead>
              {seg === "mtf" && (
                <tr>
                  <th scope="col" className="">
                    TXN DATE
                  </th>
                  <th scope="col" className="text-center">
                    NET LEDGER BAL
                  </th>
                  <th scope="col" className="text-center">
                    MTF INT AMOUNT
                  </th>
                  <th scope="col" className="text-center">
                    INTEREST RATE
                  </th>
                </tr>
              )}
              {seg === "dpc" && (
                <tr>
                  <th scope="col" className="">
                    DATE
                  </th>
                  <th scope="col" className="">
                    CLIENT CODE
                  </th>
                  <th scope="col" className="text-center">
                    LEDGER BALANCE
                  </th>
                  <th scope="col" className="text-center">
                    MARGIN
                  </th>
                  <th scope="col" className="text-center">
                    COLL VALUE
                  </th>
                  <th scope="col" className="text-center">
                    MARGIN WITH ADJUST
                  </th>
                  <th scope="col" className="text-center">
                    NON CASH
                  </th>
                  <th scope="col" className="text-center">
                    CASH COLLATREAL
                  </th>
                  <th scope="col" className="text-center">
                    MARGIN SHORTAGE
                  </th>
                  <th scope="col" className="text-center">
                    DPC BALANCE
                  </th>
                  <th scope="col" className="text-center">
                    DEBIT INT
                  </th>
                  <th scope="col" className="text-center">
                    LEDGER INT
                  </th>
                  <th scope="col" className="text-center">
                    LEDGER DPC INT
                  </th>
                  <th scope="col" className="text-center">
                    MARGIN INT
                  </th>
                  <th scope="col" className="text-center">
                    MARGIN DPC INT
                  </th>
                  <th scope="col" className="text-center">
                    DPC BALANCE CHARGES
                  </th>
                  <th scope="col" className="text-center">
                    TOTAL
                  </th>
                  {/* {hasVerticalScroll && <th className="scrollerthead"></th>} */}
                </tr>
              )}
              {seg === "prop" && (
                <tr>
                  <th scope="col" className="">
                    REPORT DATE
                  </th>
                  <th scope="col" className="">
                    CLIENT CODE
                  </th>
                  <th scope="col" className="">
                    CLIENT NAME
                  </th>
                  <th scope="col" className="text-center">
                    LEDGER BALANCE
                  </th>
                  <th scope="col" className="text-center">
                    REPLD STOCK VALUE
                  </th>
                  <th scope="col" className="text-center">
                    AVAILABLE MARGIN
                  </th>
                  <th scope="col" className="text-center">
                    EFF AVAILABLE MARGIN
                  </th>
                  <th scope="col" className="text-center">
                    PEAK MARGIN
                  </th>
                  <th scope="col" className="text-center">
                    EPN BENEFIT
                  </th>
                  <th scope="col" className="text-center">
                    NET PEAK MARGIN
                  </th>
                  <th scope="col" className="text-center">
                    EOD MARGIN
                  </th>
                  <th scope="col" className="text-center">
                    MAX MARGIN
                  </th>
                  <th scope="col" className="text-center">
                    ALLOCATION FROM PROP
                  </th>
                  <th scope="col" className="text-center">
                    DPC INT
                  </th>
                  <th scope="col" className="text-center">
                    DPC AMT
                  </th>
                  <th scope="col" className="text-center">
                    LEDGER POSTING
                  </th>
                </tr>
              )}
            </thead>
            <tbody>
              {tableData &&
                tableData.map((item, key) => {
                  return (
                    <>
                      {seg === "mtf" && (
                        <tr key={key}>
                          <td>{item?.txnDate || "-"}</td>
                          <td>{item?.netLedgerBal || 0}</td>
                          <td>{item?.mtfIntAmount || 0}</td>
                          <td>{item?.intRate || 0}</td>
                        </tr>
                      )}
                      {seg === "dpc" && (
                        <tr key={key}>
                          <td>{item?.date || "-"}</td>
                          <td>{item?.cltCode || "-"}</td>
                          <td>{item?.ledgerBalance || 0}</td>
                          <td>{item?.marginReq || 0}</td>
                          <td>{item?.collValue || 0}</td>
                          <td>{item?.marginWithAdjust || 0}</td>
                          <td>{item?.nonCashCollatreal || 0}</td>
                          <td>{item?.cashCollatreal || 0}</td>
                          <td>{item?.marginShortage || 0}</td>
                          <td>{item?.dpcBalance || 0}</td>
                          <td>{item?.debitInt || 0}</td>
                          <td>{item?.ledgerInt || 0}</td>
                          <td>{item?.ledgerDpcInt || 0}</td>
                          <td>{item?.marginInt || 0}</td>
                          <td>{item?.marginDpcInt || 0}</td>
                          <td>{item?.dpcBalanceCharges || 0}</td>
                          <td>{item?.total || 0}</td>
                        </tr>
                      )}
                      {seg === "prop" && (
                        <tr key={key}>
                          <td>{item?.reportDate || "-"}</td>
                          <td>{item?.clientCode || "-"}</td>
                          <td>{item?.clientName || "-"}</td>
                          <td>{item?.ledgerBalance || 0}</td>
                          <td>{item?.repldStockValue || 0}</td>
                          <td>{item?.availableMargin || 0}</td>
                          <td>{item?.effAvailableMarg || 0}</td>
                          <td>{item?.peakMargin || 0}</td>
                          <td>{item?.epnBenefit || 0}</td>
                          <td>{item?.netPeakMargin || 0}</td>
                          <td>{item?.eodMargin || 0}</td>
                          <td>{item?.maxMargin || 0}</td>
                          <td>{item?.allocationFromProp || 0}</td>
                          <td>{item?.dpcInt || 0}</td>
                          <td>{item?.dpcAmt || 0}</td>
                          <td>{item?.ledgerPosting || "-"}</td>
                        </tr>
                      )}
                    </>
                  );
                })}
            </tbody>
            <tbody className="interest-table-body-total">
              <tr>
                <td>Total</td>
                {seg === "dpc" ? (
                  <>
                    <td></td>
                    <td>{data?.totalLedgerBalance}</td>
                    <td>{data?.totalMarginReq}</td>
                    <td>{data?.totalCollValue}</td>
                    <td>{data?.totalMarginWithAdjust}</td>
                    <td>{data?.totalNonCashCollatreal}</td>
                    <td>{data?.totalCashCollatreal}</td>
                    <td>{data?.totalMarginShortage}</td>
                    <td>{data?.totalDpcBalance}</td>
                    <td>{data?.totalDebitInt}</td>
                    <td>{data?.totalLedgerInt}</td>
                    <td>{data?.totalLedgerDpcInt}</td>
                    <td>{data?.totalMarginInt}</td>
                    <td>{data?.totalMarginDpcInt}</td>
                    <td>{data?.totalDpcBalanceCharges}</td>
                    <td></td>
                  </>
                ) : seg === "prop" ? (
                  <>
                    <td></td>
                    <td></td>
                    <td>{data?.totalLedgerBalanceCount}</td>
                    <td>{data?.totalRepldStockValueCount}</td>
                    <td>{data?.totalAvailableMarginCount}</td>
                    <td>{data?.totalEffAvailableMargCount}</td>
                    <td>{data?.totalPeakMarginCount}</td>
                    <td>{data?.totalEPNBenefitCount}</td>
                    <td>{data?.totalNetPeakMarginCount}</td>
                    <td>{data?.totalEODMarginCount}</td>
                    <td>{data?.totalMaxMarginCount}</td>
                    <td>{data?.totalAllocationFromPropCount}</td>
                    <td>{data?.totalDPCIntCount}</td>
                    <td>{data?.totalDPCAmtCount}</td>
                    <td></td>
                  </>
                ) : (
                  <>
                    <td></td>
                    <td>{seg === "mtf" && totalMTF}</td>
                    <td></td>
                  </>
                )}
                
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};
export default InterestReportTable;
